<template>
  <div id="merchant">
    <div class="item-1">
      <div class="box-title">药品服务</div>
      <img class="bg1" src="../orderData/img/ico_bg1.svg"/>
      <div class="title">
        可在药联合作门店使用，可分多次下单，有效期{{years}}年
      </div>
      <div class="layout" v-if="list.length">
        <van-row
          type="flex"
          justify="center"
          class="one-row"
          v-for="(item, index) in list"
          :key="index"
        >
          <van-col span="8" class="flex">{{ item.marketingName }}</van-col>
          <van-col span="16" class="flex">
            <van-row type="flex" justify="space-between" class="two-row">
              <van-col
                span="24"
                v-for="(item2, index2) in item.marketingConfig"
                :key="index2"
                @click="view(item.marketingSkuNo)"
              >
                <div class="line1">每单抵扣 {{ item2.discount }}%</div>
                <div class="line2 flex">
                  <p>
                    <span>适用于&nbsp;</span>
                    {{ item2.name }}等{{ item2.num }}种药品
                  </p>
                  <p><van-icon name="arrow" color="#00B095" /></p>
                </div>
              </van-col>
            </van-row>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="item-2">
      <div class="box-title">商品详情</div>
      <div>
        <slot name="agree" ></slot>
      </div>
      <div class="intro-tabs">
          <div class="intro-tab"
                :class="introduceTabIndex===index&&'active'"
                @click="introduceTabChange(index)"
                v-for="(item,index) in tab"
                :key="index">
              <div class="tab-bg"  :style="{'background-image':'url('+ item.itemGoodsCoverImg  +')'}"></div>
              <!-- <img class="tab-bg" :src="item.itemGoodsCoverImg"/> -->
              <div class="mutil-line-ellipsis">
                  <div class="tab-name">{{item.itemGoodsTitle}}</div>
              </div>
          </div>
      </div>
      <div v-html="introduceList[introduceTabIndex]" class="htmlText"></div>
    </div>
    <div class="item-3" style="height: 3rem"></div>
  </div>
</template>
<script>
export default {
  props: {
    list: Array,
    tab: Array,
    years: String,
    skuNo: String,
  },
  data() {
    return {
      introduce: "",
      introduceTabIndex:0,
      introduceList: [],//子商品详情
    };
  },
  created() {
  },
  mounted() {
    if (this.tab && this.tab.length > 0) {
      this.get(0);
    }
  },
  methods: {
    introduceTabChange(index) {
        this.introduceTabIndex = index;
        if (this.introduceList[index]) {
            return;
        }
        this.get(index)
    },
    get(index) {
      let skuNo = this.tab[index].itemGoodsSkuNo
      this.$api.introduce({ skuNo: skuNo }).then((res) => {
        //this.introduce = res.data.introduce;
        this.introduceList[index] = res.data.introduce;
        this.introduceList = [...this.introduceList];
      });
    },
    view(skuNo) {
      // 适用商品
      this.$router.push("/yaopin?skuNo=" + skuNo);
    },
  },
};
</script>
<style lang="scss" scoped>
#merchant {
  .item-1,
  .item-2 {
    background: #fff;
    padding: 0.3rem;
    .box-title{
      font-size: 0.3rem;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 0.3rem;
      margin-bottom: 0.2rem;
    }
  }
  .item-1 {
    margin-bottom: 0.2rem;
    position: relative;
    .bg1{
      position: absolute;
      right: 0.15rem;
      top:0;
      width: 0.95rem;
      height: 0.76rem;
    }
    .title {
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      font-size: 0.2625rem;
    }
    .layout {
      border-radius: 0.08rem;
      // border: 1px solid hsl(0, 0%, 93%);
      border: 2px solid rgba(0, 176, 149, 0.3);
      background: rgba(0, 176, 149, 0.03);
      margin-top: 0.2rem;
      .one-row {
        border-bottom: 2px solid rgba(0, 176, 149, 0.3);
        ::v-deep {
          .van-col--8 {
            padding: 0.24rem;
            border-right: 2px solid rgba(0, 176, 149, 0.3);
            font-size: 0.28rem;
          }
          .van-col {
            font-size: 0.2625rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #00B095;
            &:first-child {
              text-align: center;
            }
          }
        }
        &:last-child {
          border-bottom: none;
        }
      }
      .two-row {
        position: relative;
        width: 100%;
        border-bottom: 2px solid #eeeeee;
        display: block;
        ::v-deep {
          .van-col {
            padding: 0.3rem;
            &:first-child {
              text-align: left;
            }
          }
          .van-col--24 {
            border-bottom: 2px solid rgba(0, 176, 149, 0.3);
            &:last-child {
              border-bottom: none;
            }
            .line1 {
              font-size: 0.225rem;
              color: #ff8800;
              font-family: PingFangSC-Medium, PingFang SC;
              padding-bottom: 0.1875rem;
              font-weight: 500;
            }
            .line2 {
              color: #00b095;
              line-height: 0.37rem;
              span {
                color: #333;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                line-height: 0.225rem;
              }
              p {
                &:first-child {
                  width: 87%;
                  margin-right: auto;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  font-size: 0.225rem;
                }
              }
            }
          }
        }
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
   //文字两行超出省略号
    .mutil-line-ellipsis {
        width: 100%;
        max-height: 0.6rem;
        line-height:  0.3rem;
        padding: 0 0.376rem 0 0 ;
        margin: 0.11rem 0.15rem;
        line-height:  0.3rem;
        overflow: hidden;
        box-sizing: border-box;
        white-space: pre-wrap;
    }
    /*相当于之前的prop*/
    .mutil-line-ellipsis:before {
        content: "";
        float: left;
        width: 0.09rem; /*缩小宽度为5px，其余属性不变*/
        height:  0.6rem;
    }
        /*相当于之前的main*/
    .mutil-line-ellipsis > :first-child {
        float: right;
        width: 100%;
        margin-left: -0.09rem; /*让main元素左移5px，这样main元素在宽度上就完全占满了父元素；*/
        word-break: break-all;
    }
        /*相当于之前的realEnd*/
    .mutil-line-ellipsis:after {
        content: "...";
        box-sizing: content-box;
        float: right;
        position: relative;
        width: 0.9rem;
        height:  0.3rem;
        top: - 0.3rem; /*等于高度的负值，就是文字的行高*/
        left: calc(100% + 0.09rem);
        /*而设置margin-left: -50px、padding-right: 5px则是为了让realend元素的盒模型的最终宽度计算为5px。*/
        margin-left: -0.9rem;
        padding-right: 0.09rem;
        font-size: 0.24rem;
        text-align: right;
        background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.8) 40px);
    }
  .item-2 {
     .intro-tabs {
        width: 100%;
        overflow-x: auto;
        white-space: nowrap;
        -webkit-overflow-scrolling:touch;
        padding-bottom: 0.1875rem;
        &::-webkit-scrollbar {
            display: none;
        }
        .intro-tab {
            display: inline-block;
            position: relative;
            width: 2.1rem;
            background: #FFFFFF;
            box-shadow: 0px 4px 6px 0px rgba(0, 176, 149, 0.1);
            border: 2px solid #eee;
            border-radius: 4px;
            margin-right:  0.1875rem;
            box-sizing: border-box;
            &.active{
                border-color: #00B095;
                &::after{
                    content: "";
                    position: absolute;
                    border: 2px solid #00B095;
                    width:  0.1875rem;
                    height:  0.1875rem;
                    bottom: 0;
                    left: 50%;
                    background: #fff;
                    border-top: none;
                    border-left: none;
                    border-bottom-right-radius: 2px;
                    transform: translate(-50%,50%) rotate(45deg) translateY(2px);
                }
            }
            .tab-bg {
                width: 100%;
                height: 1.7625rem;
                border-radius: 4px 4px 0 0;
                box-sizing: border-box;
                -webkit-tap-higlight-color: transparent;
                background-repeat: no-repeat;
                background-size: 100% 100%;
            }

            .tab-name {
                font-size: 0.24rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #0D0D0D;
            }
            
        }
    }
  }
}
::v-deep{
  .htmlText{
    overflow-wrap: break-word;
    p{
      word-break: normal;
    }
    img{
      width: 100%;
      display: block;
    }
  }
}
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
